import { Outlet } from 'react-router-dom';
import ThemeToggle from '../components/Header/ThemeToggle';
import Logo from '../images/logo/logo.png';
import InstallBanner from '../components/InstallBanner';

export default function AuthLayout() {
  return (
    <>
    <InstallBanner />
    <div className="flex min-h-screen flex-wrap bg-ground font-sans text-ink">
      <section aria-label="About YADA School"
        className="flex flex-[1_1_520px] flex-col justify-between gap-10 overflow-hidden bg-navy px-5 py-7 text-white sm:px-12 sm:py-10">
        <div className="flex items-center gap-3">
          <img src={Logo} alt="" className="h-10 w-10 rounded-[12px]" />
          <span className="font-display text-lg font-bold">YADA School</span>
        </div>
        <div>
          <p className="m-0 max-w-[620px] font-display text-[42px] font-extrabold leading-[0.98] tracking-[-0.045em] sm:text-[64px]">
            Every student, <em className="not-italic text-accent">one clear view.</em>
          </p>
          <p className="mt-5 max-w-[480px] text-[17px] text-on-navy-muted">
            Scores, study habits and wellbeing in one place, so teachers and counselors know who needs help this week.
          </p>
        </div>
        <div aria-hidden className="grid max-w-[640px] grid-cols-1 gap-3 sm:grid-cols-3">
          {[
            { l: 'Avg score', v: '61.4', u: '%', extra: <div className="mt-2 text-xs font-semibold text-accent">↑ 2.1 pts</div> },
            { l: 'Pass rate', v: '72', u: '%', extra: (
              <div className="mt-2 flex h-[22px] items-end gap-[3px]">
                {[40, 55, 50, 70, 100].map((h, i) => (
                  <span key={i} style={{ height: `${h}%` }} className={`flex-1 rounded-[2px] ${i === 4 ? 'bg-accent' : 'bg-navy-3'}`} />
                ))}
              </div>
            ) },
            { l: 'Open alerts', v: '9', u: '', extra: <div className="mt-2 text-xs font-semibold text-critical-soft">3 critical</div> },
          ].map(({ l, v, u, extra }) => (
            <div key={l} className="rounded-[16px] border border-navy-3 bg-navy-deep p-4">
              <div className="font-mono text-[10.5px] font-semibold uppercase tracking-[0.08em] text-on-navy-muted">{l}</div>
              <div className="mt-3 font-mono text-[30px] font-semibold leading-none tracking-[-0.03em]">{v}<span className="text-base">{u}</span></div>
              {extra}
            </div>
          ))}
        </div>
      </section>
      <section className="relative flex flex-[1_1_440px] items-center justify-center px-6 py-12">
        <div className="absolute right-5 top-5"><ThemeToggle /></div>
        <div className="w-full max-w-[400px]"><Outlet /></div>
      </section>
    </div>
    </>
  );
}
